(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function() {
  // Safely click the Inbox widget using its Shadow DOM host element.
  // Shopify Inbox injects <inbox-online-store-chat> with a shadowRoot that contains a toggle button.
  // We wait for it if necessary, then click to open.

  function getChatToggleButton() {
    var host = document.querySelector('inbox-online-store-chat');
    if (!host || !host.shadowRoot) return null;
    // Known selector inside the shadow DOM for the launcher/toggle:
    var btn =
      host.shadowRoot.querySelector('button.chat-toggle') ||
      host.shadowRoot.querySelector('[part="launcher"]') ||
      host.shadowRoot.querySelector('button'); // fallback
    return btn || null;
  }

  function openInboxNow() {
    var btn = getChatToggleButton();
    if (btn) {
      btn.click();
      return true;
    }
    return false;
  }

  function waitAndOpenInbox(maxMs) {
    var start = performance.now();
    if (openInboxNow()) return;

    // Observe for the host element or its shadow contents to appear
    var mo = new MutationObserver(function() {
      if (openInboxNow()) {
        mo.disconnect();
      } else if (performance.now() - start > maxMs) {
        mo.disconnect();
        console.warn('Shopify Inbox launcher not found in time.');
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Additionally, poll a bit just in case
    var tries = 0, intv = setInterval(function() {
      tries++;
      if (openInboxNow() || tries > Math.ceil(maxMs/200)) {
        clearInterval(intv);
      }
    }, 200);
  }

  // Bind all Chat buttons rendered by this section (supports multiple Featured product sections/blocks)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[id^="chat-inbox-btn-"]');
    if (!btn) return;

    e.preventDefault();
    // Try immediate open; if not present yet, wait up to 5s
    if (!openInboxNow()) {
      waitAndOpenInbox(5000);
    }
  }, { passive: false });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signature-disclaimer"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (!window.__dsigLibsPromise) {
    window.__dsigLibsPromise = Promise.all([
      loadScript('https://cdn.jsdelivr.net/npm/signature_pad@4.1.7/dist/signature_pad.umd.min.js'),
      loadScript('https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js'),
      loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js')
    ]);
  }
  function loadScript(src){
    return new Promise(function(res,rej){var s=document.createElement('script');s.src=src;s.defer=true;s.onload=res;s.onerror=function(){rej(new Error('Load fail '+src));};document.head.appendChild(s);});
  }

  document.querySelectorAll('.dsig[data-section-id]').forEach(function(container){
    var title       = container.dataset.title || 'Disclaimer';
    var buttonLabel = container.dataset.buttonLabel || 'Done (Save PDF)';
    var showName    = container.dataset.showName === 'true';
    var showOrder   = container.dataset.showOrder === 'true';
    var showDate    = container.dataset.showDate === 'true';

    var titleEl = container.querySelector('.dsig-title');
    if (titleEl) titleEl.textContent = title;
    var saveBtn = container.querySelector('[data-role="save"]');
    if (saveBtn) saveBtn.textContent = buttonLabel;

    var toggleAcceptance = container.querySelector('[data-role="toggle-acceptance"]');
    var acceptanceEl = container.querySelector('[data-role="acceptance"]');

    var nameInput  = container.querySelector('[data-role="name"]');
    var orderInput = container.querySelector('[data-role="order"]');
    var dateInput  = container.querySelector('[data-role="date"]');
    var printName  = container.querySelector('[data-role="print-name"]');
    var printOrder = container.querySelector('[data-role="print-order"]');
    var printDate  = container.querySelector('[data-role="print-date"]');

    if (acceptanceEl) acceptanceEl.style.display = 'none';
    if (toggleAcceptance){
      toggleAcceptance.addEventListener('change', function(){
        if (!acceptanceEl) return;
        acceptanceEl.style.display = this.checked ? '' : 'none';
      });
    }

    try {
      var u = new URL(window.location.href);
      if (showName  && nameInput  && u.searchParams.get('customer_name')) nameInput.value = u.searchParams.get('customer_name');
      if (showOrder && orderInput && u.searchParams.get('order_id'))      orderInput.value = u.searchParams.get('order_id');
      if (showDate  && dateInput  && u.searchParams.get('date'))          dateInput.value  = u.searchParams.get('date');
    } catch(e){}
    if (showDate && dateInput && !dateInput.value){
      var today = new Date(); dateInput.value = today.toISOString().slice(0,10);
    }

    function syncPrinted(){
      if (printName)  printName.textContent  = (nameInput && nameInput.value)  ? nameInput.value  : '—';
      if (printOrder) printOrder.textContent = (orderInput && orderInput.value)? orderInput.value : '—';
      if (printDate)  printDate.textContent  = (dateInput && dateInput.value)  ? dateInput.value  : '—';
    }
    [nameInput, orderInput, dateInput].forEach(function(el){ if (el) el.addEventListener('input', syncPrinted); });
    syncPrinted();

    var padCanvas  = container.querySelector('[data-role="pad"]');
    var clearBtn   = container.querySelector('[data-role="clear"]');
    var captureEl  = container.querySelector('[data-role="capture"]');
    var msgEl      = container.querySelector('[data-role="msg"]');

    window.__dsigLibsPromise.then(function(){
      var SignaturePad = window.SignaturePad;
      var html2canvas  = window.html2canvas;
      var jsPDF        = window.jspdf.jsPDF;

      var pad = new SignaturePad(padCanvas, { penColor:'#111' });
      function resizePad(){
        var ratio = Math.max(window.devicePixelRatio || 1, 1);
        var rect = padCanvas.getBoundingClientRect();
        padCanvas.width = Math.floor(rect.width * ratio);
        padCanvas.height = Math.floor(rect.height * ratio);
        var ctx = padCanvas.getContext('2d'); ctx.scale(ratio, ratio);
        pad.clear();
      }
      resizePad(); window.addEventListener('resize', resizePad);

      if (clearBtn) clearBtn.addEventListener('click', function(){ pad.clear(); if (msgEl) msgEl.textContent=''; });

      if (saveBtn) saveBtn.addEventListener('click', function () {
        if (showName && (!nameInput || !nameInput.value.trim())) { alert('Enter customer name.'); return; }
        if (showDate && (!dateInput || !dateInput.value)) { alert('Select date.'); return; }
        if (pad.isEmpty()) { alert('Signature required.'); return; }
        if (msgEl) msgEl.textContent = 'Saving…';

        var acceptanceChecked = !!(container.querySelector('[data-role="toggle-acceptance"]')?.checked);

        html2canvas(captureEl, { scale: 2, backgroundColor:'#fff', useCORS:true }).then(function (snap) {

          const imgData = snap.toDataURL('image/jpeg', 0.98);
          const pdf = new jsPDF({ unit:'pt', format:'a4', compress:true });
          const pageW = pdf.internal.pageSize.getWidth();
          const pageH = pdf.internal.pageSize.getHeight();
          const margin = 24, availW = pageW - margin*2, availH = pageH - margin*2;
          const imgW = snap.width, imgH = snap.height, ratio = imgW/imgH;
          let w = availW, h = w/ratio;
          if (h > availH) { h = availH; w = h*ratio; }
          pdf.addImage(imgData, 'JPEG', (pageW-w)/2, (pageH-h)/2, w, h, undefined, 'FAST');

          const pdfDataUrl = pdf.output('datauristring'); 

          const fd = new FormData();
          fd.append('customer_gid', new URLSearchParams(location.search).get('customer_id') || '');
          fd.append('customer_email', new URLSearchParams(location.search).get('email') || '');
          fd.append('customer_name', nameInput?.value || '');
          fd.append('order_id', orderInput?.value || new URLSearchParams(location.search).get('order_id') || '');
          fd.append('doc_type', title || 'Disclaimer');
          fd.append('signed_at', new Date().toISOString());
          fd.append('acceptance_included', (container.querySelector('[data-role="toggle-acceptance"]')?.checked ? 'true' : 'false'));

          fd.append('pdf_data_url', pdfDataUrl);

          fetch('https://script.google.com/macros/s/AKfycbyjbg3EPd8vrhE-P0RRsPBvuoG8_XBBwB25VEpISyL0JKEYg3bVtGZ08HcbxE1BgfU7/exec', {
            method: 'POST',
            body: fd 
          }).then(() => {
            msgEl && (msgEl.textContent = 'Submitted to Drive ✔');
          }).catch(err => {
            console.error(err);
            msgEl && (msgEl.textContent = 'Network error. Try again.');
          });
        });
      });

    }).catch(function(err){
      console.error(err);
      if (msgEl) msgEl.textContent = 'Failed to load signature libraries.';
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
